module.exports = __webpack_public_path__ + "img/ritz-2.473b3300.png";